var _rect, _defs, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#fff",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 800,
    height: 600,
    viewBox: "0 0 340.000000 250.000000",
    preserveAspectRatio: "xMidYMid meet",
    colorInterpolationFilters: "sRGB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 92,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fa71cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9b59b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 93,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f83600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 94,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0064d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1cb0f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 95,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f00978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3f51b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 96,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7873f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ec77ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 97,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e14fad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 98,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#009efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2af598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 99,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffcc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00b140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 100,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d51007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff8177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 102,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a2b6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c3483"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 103,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7ac5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#eea2a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 104,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ecbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#007adf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 105,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b88746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fdf5a6"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    className: "icon-text-wrapper icon-svg-group iconsvg",
    transform: "translate(81.83499908447266,62.54069519042969)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "iconsvg-imagesvg",
    transform: "translate(58.165000915527344,0)"
  }, /*#__PURE__*/React.createElement("g", null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#333",
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 60,
    height: 68.86261907494548,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 60,
    height: 68.86261907494548,
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.1300048828125 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M68.14 39.78l2.11-1.22 2.8-1.62v-3.96l-2.2-1.27-5.79 3.36-21.33 12.36-22.77-13.19-4.52-2.62-2.36 1.36v3.96l2.8 1.62 24.18 14.03V82.6l2.5 1.44 2.5-1.44V52.58l22.08-12.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#184473",
    d: "M16.88 38.56l-2.8-1.62v30.08L41.06 82.6V52.59L16.88 38.56z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#184473",
    d: "M9.12 34.07l-2.28-1.32-.01.01L0 28.79V76.3L41.06 100V88.33L9.12 69.89V34.07z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#03b6f0",
    d: "M75.8 28.84l2.47-1.44 6.45-3.73L43.73 0 2.72 23.69l8.75 5.07 32.09-18.53L75.8 28.84z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#03b6f0",
    d: "M20.96 34.24l22.77 13.19 21.33-12.36 5.79-3.36-27.29-15.75-27.12 15.66 4.52 2.62z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0582d2",
    d: "M70.25 38.56l-2.11 1.22-22.08 12.8V82.6l26.99-15.58V36.94l-2.8 1.62z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0582d2",
    d: "M80.29 32.76l-.01-.01-2.27 1.32v35.82L46.06 88.33V100l41.07-23.71v-47.5l-6.84 3.97z"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,75.86261749267578)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "tp-name iconsvg-namesvg",
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.37-27.55L16.53-22.04 5.51-22.04 5.51-5.51 18.37-5.51 18.37 0 3.67 0Q0 0 0-3.67L0-3.67 0-23.88Q0-27.55 3.67-27.55L3.67-27.55 18.37-27.55ZM27.55 0L22.04 0 22.04-16.53Q22.04-20.2 25.71-20.2L25.71-20.2 36.72-20.2 34.88-14.69 27.55-14.69 27.55 0ZM60.63-20.2L60.61 3.67Q60.61 7.35 56.94 7.35L56.94 7.35 45.92 7.35 47.76 1.84 55.1 1.84 55.1 0 42.24 0Q38.57 0 38.57-3.67L38.57-3.67 38.57-20.2 44.08-20.2 44.08-5.51 55.1-5.51 55.1-20.2 60.63-20.2ZM64.29-16.53L64.29-16.53Q64.29-20.2 67.96-20.2L67.96-20.2 82.65-20.2Q86.33-20.2 86.33-16.53L86.33-16.53 86.33-3.67Q86.33 0 82.65 0L82.65 0 71.63 0 73.47-5.51 80.82-5.51 80.82-14.69 69.8-14.69 69.8 7.35 64.29 7.35 64.29-16.53ZM90-23.88L95.51-23.88 95.51-20.2 99.18-20.2 97.35-14.71 95.51-14.71 95.51-5.51 99.18-5.51 99.18 0 93.67 0Q90 0 90-3.67L90-3.67 90-23.88ZM102.86-3.67L102.86-16.53Q102.86-20.2 106.53-20.2L106.53-20.2 121.22-20.2Q124.9-20.2 124.9-16.53L124.9-16.53 124.9 0 119.39 0 119.37-14.69 108.37-14.69 108.37-5.51 117.55-5.51 115.71 0 106.55 0Q102.86 0 102.86-3.67L102.86-3.67ZM146.94-20.2L146.94-20.2Q150.61-20.2 150.61-16.53L150.61-16.53 150.61 3.67Q150.61 7.35 146.94 7.35L146.94 7.35 135.92 7.35 137.76 1.84 145.1 1.84 145.1-14.69 134.08-14.69 134.08-5.51 143.27-5.51 141.43 0 132.24 0Q128.57 0 128.57-3.67L128.57-3.67 128.57-16.53Q128.57-20.2 132.24-20.2L132.24-20.2 146.94-20.2ZM176.33-16.53L176.33-3.67Q176.33 0 172.65 0L172.65 0 157.96 0Q154.29 0 154.29-3.67L154.29-3.67 154.29-16.53Q154.29-20.2 157.96-20.2L157.96-20.2 172.65-20.2Q176.33-20.2 176.33-16.53L176.33-16.53ZM170.82-14.69L159.8-14.69 159.8-5.51 170.82-5.51 170.82-14.69Z",
    transform: "translate(0, 27.549999237060547)"
  })))), /*#__PURE__*/React.createElement("g", {
    fillRule: "",
    className: "tp-slogan iconsvg-slogansvg",
    fill: "#333",
    transform: "translate(5,40.89999771118164)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    height: 1,
    y: 3.580000400543213,
    width: 18.174999237060547
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    y: 3.580000400543213,
    width: 18.174999237060547,
    x: 148.15500259399414
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.174999237060547,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-7.87L2.52 0L3.68 0L6.18-7.87L5.16-7.87L3.90-3.62C3.76-3.15 3.64-2.72 3.53-2.32C3.42-1.92 3.29-1.48 3.14-1.02L3.10-1.02C2.94-1.48 2.81-1.92 2.71-2.32C2.60-2.72 2.47-3.15 2.33-3.62L1.07-7.87ZM7.26-7.87L7.26 0L8.26 0L8.26-7.87ZM10.44-1.72L9.84-1.02C10.18-0.66 10.59-0.38 11.06-0.17C11.54 0.04 12.05 0.14 12.60 0.14C13.02 0.14 13.39 0.09 13.72-0.03C14.04-0.15 14.32-0.31 14.56-0.51C14.79-0.71 14.97-0.95 15.09-1.22C15.21-1.50 15.28-1.79 15.28-2.10C15.28-2.39 15.23-2.64 15.15-2.86C15.07-3.08 14.95-3.27 14.81-3.44C14.66-3.60 14.49-3.75 14.29-3.87C14.09-3.99 13.88-4.10 13.66-4.20L12.54-4.68C12.38-4.74 12.22-4.81 12.07-4.89C11.92-4.97 11.78-5.05 11.65-5.15C11.52-5.25 11.42-5.37 11.35-5.50C11.27-5.63 11.23-5.80 11.23-5.99C11.23-6.35 11.37-6.63 11.63-6.83C11.90-7.04 12.26-7.14 12.70-7.14C13.06-7.14 13.39-7.07 13.69-6.94C13.98-6.81 14.24-6.63 14.48-6.40L15.02-7.04C14.74-7.33 14.40-7.57 14.00-7.75C13.60-7.93 13.17-8.02 12.70-8.02C12.34-8.02 12.01-7.96 11.71-7.86C11.41-7.76 11.15-7.61 10.93-7.42C10.71-7.23 10.53-7.01 10.41-6.76C10.29-6.50 10.22-6.22 10.22-5.93C10.22-5.64 10.27-5.39 10.37-5.17C10.46-4.95 10.59-4.76 10.74-4.60C10.89-4.44 11.06-4.30 11.26-4.19C11.45-4.08 11.64-3.98 11.82-3.90L12.95-3.41C13.13-3.32 13.30-3.24 13.46-3.16C13.62-3.08 13.76-2.99 13.88-2.89C13.99-2.79 14.09-2.67 14.15-2.53C14.22-2.39 14.26-2.22 14.26-2.02C14.26-1.63 14.11-1.32 13.82-1.09C13.54-0.85 13.13-0.73 12.61-0.73C12.20-0.73 11.81-0.82 11.43-1.00C11.05-1.18 10.72-1.42 10.44-1.72ZM16.82-7.87L16.82 0L17.82 0L17.82-7.87ZM22.88 0.14C23.38 0.14 23.83 0.05 24.25-0.14C24.66-0.34 25.01-0.61 25.31-0.97C25.61-1.32 25.85-1.75 26.01-2.26C26.17-2.77 26.26-3.34 26.26-3.97C26.26-4.60 26.17-5.16 26.01-5.66C25.85-6.16 25.61-6.58 25.31-6.93C25.01-7.28 24.66-7.55 24.25-7.73C23.83-7.92 23.38-8.02 22.88-8.02C22.39-8.02 21.93-7.92 21.52-7.74C21.11-7.56 20.76-7.29 20.46-6.94C20.16-6.59 19.93-6.17 19.77-5.67C19.61-5.17 19.52-4.60 19.52-3.97C19.52-3.34 19.61-2.77 19.77-2.26C19.93-1.75 20.16-1.32 20.46-0.97C20.76-0.61 21.11-0.34 21.52-0.14C21.93 0.05 22.39 0.14 22.88 0.14ZM22.88-0.73C22.53-0.73 22.21-0.81 21.93-0.96C21.65-1.11 21.40-1.33 21.20-1.61C20.99-1.90 20.84-2.24 20.72-2.63C20.61-3.03 20.56-3.48 20.56-3.97C20.56-4.46 20.61-4.90 20.72-5.29C20.84-5.68 20.99-6.02 21.20-6.29C21.40-6.56 21.65-6.77 21.93-6.92C22.21-7.07 22.53-7.14 22.88-7.14C23.24-7.14 23.55-7.07 23.84-6.92C24.12-6.77 24.37-6.56 24.57-6.29C24.77-6.02 24.93-5.68 25.04-5.29C25.16-4.90 25.21-4.46 25.21-3.97C25.21-3.48 25.16-3.03 25.04-2.63C24.93-2.24 24.77-1.90 24.57-1.61C24.37-1.33 24.12-1.11 23.84-0.96C23.55-0.81 23.24-0.73 22.88-0.73ZM27.95-7.87L27.95 0L28.90 0L28.90-4.12C28.90-4.53 28.88-4.95 28.85-5.36C28.83-5.77 28.80-6.18 28.76-6.58L28.81-6.58L29.66-4.96L32.52 0L33.55 0L33.55-7.87L32.60-7.87L32.60-3.80C32.60-3.39 32.62-2.97 32.65-2.54C32.67-2.11 32.70-1.70 32.72-1.30L32.68-1.30L31.82-2.93L28.98-7.87ZM41.48-3.20L39.12-3.20L39.49-4.40C39.64-4.84 39.77-5.28 39.90-5.72C40.03-6.15 40.15-6.60 40.27-7.06L40.32-7.06C40.45-6.60 40.58-6.15 40.70-5.72C40.83-5.28 40.97-4.84 41.11-4.40ZM41.74-2.40L42.48 0L43.55 0L40.88-7.87L39.76-7.87L37.09 0L38.11 0L38.87-2.40ZM44.66-7.87L44.66 0L45.61 0L45.61-4.12C45.61-4.53 45.60-4.95 45.57-5.36C45.54-5.77 45.51-6.18 45.48-6.58L45.53-6.58L46.38-4.96L49.24 0L50.27 0L50.27-7.87L49.32-7.87L49.32-3.80C49.32-3.39 49.33-2.97 49.36-2.54C49.39-2.11 49.42-1.70 49.44-1.30L49.39-1.30L48.54-2.93L45.70-7.87ZM52.43-7.87L52.43 0L54.44 0C55.04 0 55.56-0.09 56.02-0.27C56.47-0.45 56.86-0.71 57.17-1.05C57.48-1.39 57.72-1.81 57.88-2.30C58.04-2.79 58.12-3.35 58.12-3.97C58.12-5.23 57.80-6.19 57.17-6.86C56.54-7.54 55.61-7.87 54.40-7.87ZM54.32-0.82L53.42-0.82L53.42-7.06L54.32-7.06C55.24-7.06 55.93-6.79 56.39-6.26C56.85-5.74 57.08-4.97 57.08-3.97C57.08-2.97 56.85-2.20 56.39-1.64C55.93-1.09 55.24-0.82 54.32-0.82ZM62.23-7.87L62.23 0L63.23 0L63.23-7.87ZM65.39-7.87L65.39 0L66.34 0L66.34-4.12C66.34-4.53 66.32-4.95 66.29-5.36C66.27-5.77 66.24-6.18 66.20-6.58L66.25-6.58L67.10-4.96L69.96 0L70.99 0L70.99-7.87L70.04-7.87L70.04-3.80C70.04-3.39 70.06-2.97 70.09-2.54C70.11-2.11 70.14-1.70 70.16-1.30L70.12-1.30L69.26-2.93L66.42-7.87ZM73.15-7.87L73.15 0L74.10 0L74.10-4.12C74.10-4.53 74.09-4.95 74.06-5.36C74.03-5.77 74.00-6.18 73.97-6.58L74.02-6.58L74.87-4.96L77.72 0L78.76 0L78.76-7.87L77.81-7.87L77.81-3.80C77.81-3.39 77.82-2.97 77.85-2.54C77.88-2.11 77.90-1.70 77.93-1.30L77.88-1.30L77.03-2.93L74.18-7.87ZM83.82 0.14C84.32 0.14 84.77 0.05 85.18-0.14C85.59-0.34 85.95-0.61 86.25-0.97C86.55-1.32 86.78-1.75 86.95-2.26C87.11-2.77 87.19-3.34 87.19-3.97C87.19-4.60 87.11-5.16 86.95-5.66C86.78-6.16 86.55-6.58 86.25-6.93C85.95-7.28 85.59-7.55 85.18-7.73C84.77-7.92 84.32-8.02 83.82-8.02C83.32-8.02 82.87-7.92 82.46-7.74C82.05-7.56 81.69-7.29 81.40-6.94C81.10-6.59 80.87-6.17 80.71-5.67C80.54-5.17 80.46-4.60 80.46-3.97C80.46-3.34 80.54-2.77 80.71-2.26C80.87-1.75 81.10-1.32 81.40-0.97C81.69-0.61 82.05-0.34 82.46-0.14C82.87 0.05 83.32 0.14 83.82 0.14ZM83.82-0.73C83.47-0.73 83.15-0.81 82.87-0.96C82.58-1.11 82.34-1.33 82.13-1.61C81.93-1.90 81.77-2.24 81.66-2.63C81.55-3.03 81.49-3.48 81.49-3.97C81.49-4.46 81.55-4.90 81.66-5.29C81.77-5.68 81.93-6.02 82.13-6.29C82.34-6.56 82.58-6.77 82.87-6.92C83.15-7.07 83.47-7.14 83.82-7.14C84.17-7.14 84.49-7.07 84.77-6.92C85.06-6.77 85.30-6.56 85.51-6.29C85.71-6.02 85.87-5.68 85.98-5.29C86.09-4.90 86.15-4.46 86.15-3.97C86.15-3.48 86.09-3.03 85.98-2.63C85.87-2.24 85.71-1.90 85.51-1.61C85.30-1.33 85.06-1.11 84.77-0.96C84.49-0.81 84.17-0.73 83.82-0.73ZM87.68-7.87L90.20 0L91.37 0L93.86-7.87L92.84-7.87L91.58-3.62C91.45-3.15 91.32-2.72 91.21-2.32C91.10-1.92 90.97-1.48 90.83-1.02L90.78-1.02C90.63-1.48 90.50-1.92 90.39-2.32C90.28-2.72 90.16-3.15 90.01-3.62L88.75-7.87ZM98.12-3.20L95.76-3.20L96.13-4.40C96.28-4.84 96.41-5.28 96.54-5.72C96.67-6.15 96.79-6.60 96.91-7.06L96.96-7.06C97.09-6.60 97.22-6.15 97.34-5.72C97.47-5.28 97.61-4.84 97.75-4.40ZM98.38-2.40L99.12 0L100.19 0L97.52-7.87L96.40-7.87L93.73 0L94.75 0L95.51-2.40ZM102.46-7.03L102.46 0L103.46 0L103.46-7.03L105.84-7.03L105.84-7.87L100.08-7.87L100.08-7.03ZM107.26-7.87L107.26 0L108.25 0L108.25-7.87ZM113.32 0.14C113.81 0.14 114.27 0.05 114.68-0.14C115.09-0.34 115.45-0.61 115.75-0.97C116.05-1.32 116.28-1.75 116.44-2.26C116.61-2.77 116.69-3.34 116.69-3.97C116.69-4.60 116.61-5.16 116.44-5.66C116.28-6.16 116.05-6.58 115.75-6.93C115.45-7.28 115.09-7.55 114.68-7.73C114.27-7.92 113.81-8.02 113.32-8.02C112.82-8.02 112.37-7.92 111.95-7.74C111.54-7.56 111.19-7.29 110.89-6.94C110.60-6.59 110.37-6.17 110.20-5.67C110.04-5.17 109.96-4.60 109.96-3.97C109.96-3.34 110.04-2.77 110.20-2.26C110.37-1.75 110.60-1.32 110.89-0.97C111.19-0.61 111.54-0.34 111.95-0.14C112.37 0.05 112.82 0.14 113.32 0.14ZM113.32-0.73C112.96-0.73 112.65-0.81 112.36-0.96C112.08-1.11 111.83-1.33 111.63-1.61C111.43-1.90 111.27-2.24 111.16-2.63C111.04-3.03 110.99-3.48 110.99-3.97C110.99-4.46 111.04-4.90 111.16-5.29C111.27-5.68 111.43-6.02 111.63-6.29C111.83-6.56 112.08-6.77 112.36-6.92C112.65-7.07 112.96-7.14 113.32-7.14C113.67-7.14 113.99-7.07 114.27-6.92C114.55-6.77 114.80-6.56 115.00-6.29C115.21-6.02 115.36-5.68 115.48-5.29C115.59-4.90 115.64-4.46 115.64-3.97C115.64-3.48 115.59-3.03 115.48-2.63C115.36-2.24 115.21-1.90 115.00-1.61C114.80-1.33 114.55-1.11 114.27-0.96C113.99-0.81 113.67-0.73 113.32-0.73ZM118.38-7.87L118.38 0L119.33 0L119.33-4.12C119.33-4.53 119.31-4.95 119.29-5.36C119.26-5.77 119.23-6.18 119.20-6.58L119.24-6.58L120.10-4.96L122.95 0L123.98 0L123.98-7.87L123.04-7.87L123.04-3.80C123.04-3.39 123.05-2.97 123.08-2.54C123.11-2.11 123.13-1.70 123.16-1.30L123.11-1.30L122.26-2.93L119.41-7.87Z",
    transform: "translate(0, 8.016)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7ea54a2572e80ff45a97ce4a9e789fb5.svg";
export { ForwardRef as ReactComponent };